import { cva, type VariantProps } from "class-variance-authority";
import { Slot as SlotPrimitive } from "radix-ui";
import type * as React from "react";
import type { Ref } from "react";
import { cn } from "../../lib/utils";
const headingVariants = cva("font-semibold text-gray-950 dark:text-white", {
  variants: {
    variant: {
      h1: "text-4xl @md:text-5xl",
      h2: "text-3xl @md:text-4xl",
      h3: "text-2xl @md:text-3xl",
      h4: "text-xl @md:text-2xl",
      h5: "text-lg @md:text-xl",
      h6: "text-base @md:text-lg"
    },
    fontFamily: {
      brand: "font-heading"
    }
  },
  compoundVariants: [{
    variant: "h1",
    fontFamily: "brand",
    className: "font-bold"
  }, {
    variant: "h2",
    fontFamily: "brand",
    className: "font-bold"
  }, {
    variant: "h3",
    fontFamily: "brand",
    className: "font-semibold"
  }, {
    variant: "h4",
    fontFamily: "brand",
    className: "font-semibold"
  }, {
    variant: "h5",
    fontFamily: "brand",
    className: "font-semibold"
  }, {
    variant: "h6",
    fontFamily: "brand",
    className: "font-semibold"
  }],
  defaultVariants: {
    variant: "h1",
    fontFamily: "brand"
  }
});
export interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement>, VariantProps<typeof headingVariants> {
  asChild?: boolean;
  ref?: Ref<HTMLHeadingElement>;
}
const Heading = ({
  className,
  variant,
  fontFamily,
  asChild = false,
  ref,
  ...props
}: HeadingProps) => {
  const Comp = asChild ? SlotPrimitive.Slot : variant ?? "h1";
  return <Comp className={cn(headingVariants({
    variant,
    fontFamily
  }), className)} ref={ref} {...props} data-sentry-element="Comp" data-sentry-component="Heading" data-sentry-source-file="heading.tsx" />;
};
const Alpha = (props: Omit<HeadingProps, "variant">) => <Heading variant="h1" {...props} data-sentry-element="Heading" data-sentry-component="Alpha" data-sentry-source-file="heading.tsx" />;
const Bravo = (props: Omit<HeadingProps, "variant">) => <Heading variant="h2" {...props} data-sentry-element="Heading" data-sentry-component="Bravo" data-sentry-source-file="heading.tsx" />;
const Charlie = (props: Omit<HeadingProps, "variant">) => <Heading variant="h3" {...props} data-sentry-element="Heading" data-sentry-component="Charlie" data-sentry-source-file="heading.tsx" />;
const Delta = (props: Omit<HeadingProps, "variant">) => <Heading variant="h4" {...props} data-sentry-element="Heading" data-sentry-component="Delta" data-sentry-source-file="heading.tsx" />;
const Echo = (props: Omit<HeadingProps, "variant">) => <Heading variant="h5" {...props} data-sentry-element="Heading" data-sentry-component="Echo" data-sentry-source-file="heading.tsx" />;
const Foxtrot = (props: Omit<HeadingProps, "variant">) => <Heading variant="h6" {...props} data-sentry-element="Heading" data-sentry-component="Foxtrot" data-sentry-source-file="heading.tsx" />;
export { Alpha, Bravo, Charlie, Delta, Echo, Foxtrot, Heading, headingVariants };